import { SiteHeader as Header } from "@twinkltech/curriculum-architect-component-library";
import { useTwinklAnalytics } from "@twinkltech/web-analytics-ts";
import { useId } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { COMMON_NS } from "@/i18n/common/common.i18n";

import { APP_HEADER_NS } from "./AppHeader.i18n";
import { AccountActionMenu } from "./sub-components/AccountActionMenu/AccountActionMenu";
import { CurriculumArchitectLogo } from "./sub-components/CurriculumArchitectLogo/CurriculumArchitectLogo";

export const AppHeader = () => {
  const { t } = useTranslation(APP_HEADER_NS);
  const headerA11yLabel = useId();

  const { click } = useTwinklAnalytics();

  const handlerAnalyticsClickEvent = (menuName: string) => {
    click("curriculum_architect_click_top_menu", {
      menuName,
    });
  };

  return (
    <Header>
      <Header.Identity>
        <Link
          aria-labelledby={headerA11yLabel}
          to="."
          onClick={() => handlerAnalyticsClickEvent("Home")}
        >
          <CurriculumArchitectLogo
            aria-labelledby={headerA11yLabel}
            role="presentation"
          />
          <span className="sr-only" id={headerA11yLabel}>
            {t("identity.site-title", { ns: COMMON_NS })}
          </span>
        </Link>
      </Header.Identity>
      <Header.Actions>
        <AccountActionMenu />
      </Header.Actions>
    </Header>
  );
};
